function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIzquierda = function SvgIzquierda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 134 134"
  }, props), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.581,
    cy: 66.653,
    rx: 64.01,
    ry: 64.438,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 50 58.333 66.667 75 83.333",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "CurrentColor",
      strokeWidth: "6.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.667 129.167c34.518 0 62.5-27.982 62.5-62.5s-27.982-62.5-62.5-62.5-62.5 27.982-62.5 62.5 27.982 62.5 62.5 62.5Zm0 4.166c36.819 0 66.666-29.847 66.666-66.666C133.333 29.848 103.486 0 66.667 0 29.848 0 0 29.848 0 66.667s29.848 66.666 66.667 66.666Z",
    style: {
      fill: "CurrentColor"
    }
  }));
};
export default SvgIzquierda;